import { alpha } from '@mui/material/styles';
import { mediaQuery } from 'common/theme/media';
import styled, { css } from 'styled-components';

export const Mobile = css`
    .ticket-card {
        padding: 8px;
    }
`;
export const Tablet = css`
    .ticket-card {
        padding: 8px;
    }
`;

export const PageStyled = styled.div`
    .ticket {
        padding: 8px;
        background-color: #fff;
        border-radius: 12px;
        border: solid 1px ${alpha('#c1c3c8', 0.4)};
        outline-offset: -1px;
        display: flex;
        flex-direction: column;
        position: relative;
        overflow: hidden;
        color: #303641;
        width: 100%;
        opacity: 0;
        transform: translateY(10vh);
        visibility: hidden;
        transition: opacity 0.4s ease-out, transform 0.4s ease-out;
        will-change: opacity, visibility;
        margin: 2px 0;
        user-select: none;
        &:hover {
            border-color: var(--mui-palette-primary-main);
            outline: solid 2px var(--mui-palette-primary-main);
            cursor: pointer;
        }
        &.active {
            border-color: var(--mui-palette-secondary-main);
            outline: solid 2px var(--mui-palette-secondary-main);
        }
        &.fade-in {
            opacity: 1;
            transform: none;
            visibility: visible;
        }

        .ticket-card {
            position: relative;
            color: #303641;
            display: flex;
            flex-direction: column;

            gap: 8px;
            .row {
                display: flex;
                flex-wrap: nowrap;
                gap: 8px;
                flex-direction: row;
            }

            .column-1 {
                display: flex;
                flex-direction: column;

                .thumbnail {
                    border-radius: 6px;
                    width: 92px;
                    height: 100%;
                    padding: 0;
                    margin: 0;
                    overflow: hidden;
                    position: relative;
                    .thumbnail-badge {
                        padding: 3px 6px;
                        background-color: #fff;
                        color: #fff;
                        font-size: 10px;
                        font-weight: 600;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;
                        gap: 3px;
                        width: fit-content;
                        border-radius: 6px;
                        position: absolute;
                        left: 6px;
                        top: 6px;
                        transform: scale(0.7);
                        transform-origin: left top;
                    }
                    img {
                        height: 100%;
                        object-fit: cover;
                        width: 100%;
                    }
                    .thumbnail-vote {
                        position: absolute;
                        left: 6px;
                        bottom: 6px;
                        /* transform: scale(0.85); */
                        transform-origin: left bottom;
                    }
                }
            }
            .column-2 {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                flex: 1;
                gap: 5px;

                .hotel-feature {
                    .custom-text {
                        font-size: 12px;
                    }
                }
                .vote-bar {
                    flex-direction: column;
                    align-items: flex-end;
                    width: 100%;
                }
            }
            .column-3 {
                display: flex;
                flex-direction: row;
                margin-top: 12px;
                justify-content: space-between;
                width: 100%;
            }

            .ticket-title {
                font-size: 12px;
                font-weight: 700;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .ticket-rating {
                line-height: 22px;
            }
            .location {
                font-size: 12px;
                color: var(--mui-palette-primary-main);
                text-decoration: underline;
                cursor: pointer;
                font-weight: 500;
                .material-icons {
                    font-size: 1rem;
                }
            }
            .location-km {
                font-size: 14px;
                color: #646a76;
                .material-icons {
                    font-size: 1rem;
                }
            }
            .alert-box {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 8px;
                .mini-alert {
                    padding: 3px 8px;
                }
            }
            .bottom-box {
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: flex-end;
                justify-content: space-between;
                .left {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 3px;
                }
            }
            .guest-info {
                font-size: 10px;
            }
            .price-discount {
                color: var(--mui-palette-secondary-main);
                font-weight: 700;

                border-radius: 4px;
                font-size: 10px;
                display: flex;
                justify-content: flex-end;
                margin-bottom: 5px;
                white-space: nowrap;
                .material-icons {
                    font-size: 12px;
                    line-height: 12px;
                }
            }
            .price-info {
                color: #c1c3c8;
                font-size: 1rem;
            }
            .buttons {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
            }
            .price-box {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                gap: 8px;
                .old-price {
                    font-size: 12px;
                    font-weight: 700;
                }
                .ticket-price {
                    font-size: 16px;
                    font-weight: 700;
                }
            }
        }
    }

    ${mediaQuery.lessThan('xltablet')`${Tablet}`}
    ${mediaQuery.lessThan('mobile')`${Mobile}`}
`;
